module.exports={
  "_args": [
    [
      "libxmljs2@0.29.0",
      "/P/SLXOLIVIO"
    ]
  ],
  "_from": "libxmljs2@0.29.0",
  "_id": "libxmljs2@0.29.0",
  "_inBundle": false,
  "_integrity": "sha512-g9PvujoUGRHBp2R7Z49pKklMdAucayepGSJajfpzl+JlGRO1lHfWWH1KQcwqoylO524G9Mu9pO74ZaQ11fi0/w==",
  "_location": "/libxmljs2",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "libxmljs2@0.29.0",
    "name": "libxmljs2",
    "escapedName": "libxmljs2",
    "rawSpec": "0.29.0",
    "saveSpec": null,
    "fetchSpec": "0.29.0"
  },
  "_requiredBy": [
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/libxmljs2/-/libxmljs2-0.29.0.tgz",
  "_spec": "0.29.0",
  "_where": "/P/SLXOLIVIO",
  "author": {
    "name": "marudor"
  },
  "binary": {
    "module_name": "xmljs",
    "module_path": "./build/Release/",
    "host": "https://github.com",
    "remote_path": "./marudor/libxmljs2/releases/download/v{version}/",
    "package_name": "{node_abi}-{platform}-{arch}-{libc}.tar.gz"
  },
  "bugs": {
    "url": "http://github.com/marudor/libxmljs2/issues"
  },
  "contributors": [
    {
      "name": "Jeff Smick"
    },
    {
      "name": "Marco Rogers"
    }
  ],
  "dependencies": {
    "@mapbox/node-pre-gyp": "^1.0.5",
    "bindings": "~1.5.0",
    "nan": "~2.15.0"
  },
  "description": "libxml bindings for v8 javascript engine",
  "devDependencies": {
    "babel-eslint": "^10.1.0",
    "eslint": "^7.32.0",
    "eslint-config-marudor": "^8.0.1",
    "jest": "^27.3.1",
    "jest-watch-typeahead": "^1.0.0",
    "prettier": "^2.4.1",
    "tsd": "^0.18.0",
    "typescript": "^4.4.4"
  },
  "engines": {
    "node": ">=12"
  },
  "files": [
    "index.js",
    "index.d.ts",
    "src",
    "lib",
    "vendor",
    "binding.gyp",
    "Makefile"
  ],
  "homepage": "https://github.com/marudor/libxmljs2#readme",
  "license": "MIT",
  "main": "./index",
  "name": "libxmljs2",
  "repository": {
    "type": "git",
    "url": "git+ssh://git@github.com/marudor/libxmljs2.git"
  },
  "scripts": {
    "build": "node-pre-gyp install --build-from-source",
    "install": "node-pre-gyp install --fallback-to-build --loglevel http",
    "lint": "eslint index.js test",
    "package": "node-pre-gyp package 2>&1",
    "test": "node --expose_gc ./node_modules/jest/bin/jest.js",
    "tsd": "tsd"
  },
  "version": "0.29.0"
}
